import { useState } from "react";
import { ListTree } from "lucide-react";
import KorteOpmaak from "./KorteOpmaak";
import { splitsBron } from "@/lib/workerUitslag";
import { useTaal } from "@/contexts/TaalContext";

/** De uitslag van een worker in de Postbus: het antwoord, en het bronblok alleen op verzoek.
 *  Fix 4 (Frank, 5 nov 2026); zie `lib/workerUitslag.js`. */
export default function WorkerUitslag({ antwoord }) {
  const { t } = useTaal();
  const [open, setOpen] = useState(false);
  const { tekst, bron } = splitsBron(antwoord);
  return (
    <>
      {/* Glasronde 0.9.246 punt 4: de opmaak van de worker als opmaak, niet als losse sterretjes. */}
      <KorteOpmaak tekst={tekst} testid="postbus-worker-tekst" />
      {bron && (
        <div>
          <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open}
                  className="inline-flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground hover:text-foreground"
                  data-testid="postbus-worker-werk">
            <ListTree className="h-3 w-3" />
            {t("Laat je werk zien")}
          </button>
          {open && (
            <pre className="mt-1 max-h-64 overflow-auto whitespace-pre-wrap break-words text-[11px] text-muted-foreground"
                 data-testid="postbus-worker-bron">
              {bron}
            </pre>
          )}
        </div>
      )}
    </>
  );
}
